module.exports = __webpack_public_path__ + "img/finger.3b701886.png";